import React, { useContext } from "react";
import styled from "styled-components";
import { TrackerContext } from "./utils/types";
const StyledButton = styled.button`
  height: 34px;
  padding: 0 18px;
  font-weight: 700;
  font-size: 14px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  outline: none;
  transition: all 0.3s ease;
  background-color: ${(props) => props.color || "#237804"};
  color: white;
  white-space: nowrap;

  &:hover {
    background-color: ${(props) => `${props.color}cc` || "#237804cc"};
    transform: scale(1.01);
  }
`;
const SaveButton: React.FC = () => {
  const {
    trackerLoading,
    startTracking,
    typeOfTracking,
    createSession,
    stopTracking,
    isTracking,
  } = useContext(TrackerContext);

  return (
    <>
      {typeOfTracking === "Manual" ? (
        <StyledButton
          onClick={() => createSession()}
          disabled={isTracking || trackerLoading}
          color="#237804"
        >
          {trackerLoading ? "Loading..." : "Save"}
        </StyledButton>
      ) : (
        <>
          {!isTracking ? (
            <StyledButton
              onClick={() => startTracking()}
              disabled={isTracking || trackerLoading}
              color="#1890ff"
            >
              {trackerLoading ? "Loading..." : "Start"}
            </StyledButton>
          ) : (
            <StyledButton
              onClick={stopTracking}
              disabled={!isTracking || trackerLoading}
              color="#f5222d"
            >
              Stop
            </StyledButton>
          )}
        </>
      )}
    </>
  );
};
export default SaveButton;
